document.addEventListener("DOMContentLoaded", initEmblaCarousel);
document.addEventListener("shopify:section:load", initEmblaCarousel);

function initEmblaCarousel() {
  document.querySelectorAll(".embla").forEach((emblaNode) => {
    // Prevent initializing twice
    if (emblaNode.dataset.emblaInitialized) return;
    emblaNode.dataset.emblaInitialized = "true";

    const viewport = emblaNode.querySelector(".embla__viewport");
    const prevBtn = emblaNode.querySelector(".embla__prev");
    const nextBtn = emblaNode.querySelector(".embla__next");

    if (!viewport || typeof EmblaCarousel === "undefined") {
      console.error("Embla is not loaded.");
      return;
    }

    const embla = EmblaCarousel(viewport, {
      loop: true,
      align: "start",
      draggable: true,
      dragFree: false,
      containScroll: "trimSnaps",
      skipSnaps: false,
      duration: 25
    });

    // Previous button
    if (prevBtn) {
      prevBtn.addEventListener("click", () => embla.scrollPrev());
    }

    // Next button
    if (nextBtn) {
      nextBtn.addEventListener("click", () => embla.scrollNext());
    }

    // Enable / Disable buttons
    function updateButtons() {
      if (!prevBtn || !nextBtn) return;

      if (embla.canScrollPrev()) {
        prevBtn.removeAttribute("disabled");
      } else {
        prevBtn.setAttribute("disabled", "disabled");
      }

      if (embla.canScrollNext()) {
        nextBtn.removeAttribute("disabled");
      } else {
        nextBtn.setAttribute("disabled", "disabled");
      }
    }

    embla.on("select", updateButtons);
    embla.on("init", updateButtons);
    embla.on("reInit", updateButtons);

    updateButtons();

    // Refresh when window resizes
    window.addEventListener("resize", () => {
      embla.reInit();
    });
  });
}